<template>
  <div class="rescue global-rescue">
    <BackTop></BackTop>
    <div class="main">
      <Breadcrumb class="bread rescueBread"
                  separator=">">
        <BreadcrumbItem to="/">
          <img class="bread-icon"
               src="../assets/images/icon-location.png" />首页
        </BreadcrumbItem>
        <BreadcrumbItem to="/rescue">全球救援</BreadcrumbItem>
        <BreadcrumbItem class="bread-last">紧急医疗救援</BreadcrumbItem>
      </Breadcrumb>
      <h3 class="rescue-bigtitle"
          style="margin-bottom:30px;">紧急医疗救援--非会员委托服务</h3>
      <p class="experience-para"
         style="margin-bottom:100px;">
        针对非会员客户（企业或者个人）委托的个案，制定方案并提供服务。包括提供活动集会现场救援，及重症紧急救援（医疗转运或者 遗体转运）等服务。

      </p>
      <h4 class="rescue-title"
          style="margin-bottom:0;">活动集会现场救援</h4>
      <div class="customer-block">
        <h5 class="case-title">周边环境及医疗机构信息调查</h5>
        <p>调查活动集会周边的医疗机构信息，事先与现场消防相关部门进行面谈，掌握周边环境信息。</p>
      </div>
      <div class="customer-block">
        <h5 class="case-title">制作紧急救援计划及救护指南，构筑现地紧急救援体制</h5>
        <p>根据预想的意外事故或突发疾病进行救援演习，确保安全管理体制并作成救护手册。</p>
      </div>
      <div class="customer-block">
        <h5 class="case-title">派遣救护人员在现场随时待命</h5>
        <p>根据预想的意外事故或突发疾病配置适合的现场救护人员，确保在事故发生时迅速急救以 及转移到适当医院。</p>
      </div>
      <div class="customer-block"
           style="border:none;">
        <h5 class="case-title">给委托方提出活动报告</h5>
        <p>在活动结束后，就事故和急病患者的情况以及救援内容等作出详细报告。</p>
      </div>
      <div class="img-box">
        <img class="case-img" :src="Individual04" alt="">
      </div>
      <h4 class="rescue-title">重症紧急救援</h4>
      <div class="experience-part">
        <p class="more-case">医疗转运流程</p>
      </div>
      <div class="experience-part">
        <p class="experience-para"
           style="margin-bottom:40px;">
          从接到案件委托开始到转运实行根据具体情况大约需要3～7天的准备时间。
        </p>
        <img class="case-img individual03"
             :src="Individual03"
             style="width: 928px;height: 852px;"
             alt="">
      </div>
      <div class="experience-part">
        <p class="more-case">遗体转运流程</p>
      </div>
      <div class="experience-part">
        <p class="experience-para"
           style="margin-bottom:40px;">
          国际遗体转运在取得死亡证明书后的转运准备需要3～7天。<br/> 需要以货运形式通关，且密封棺木体积大，无法搭乘小型航班。
          <br/> 根据当地情况有可能需要先通过地面转运到临近大型城市有国际运尸资质的殡仪馆进行操作。
        </p>
        <img class="case-img"
             :src="Individual02"
             style="width: 928px;height: 852px;"
             alt="">
      </div>
    </div>
  </div>
</template>
<script>
import worldnet1 from '@/assets/images/rescue/worldnet1.jpg'
import Individual01 from '@/assets/images/rescue/case03.jpg';
import Individual02 from '@/assets/images/rescue/case01.png';
import Individual03 from '@/assets/images/rescue/case02.png';
import Individual04 from '@/assets/images/rescue/on-site-rescue.png';
export default {
  data () {
    return {
      Individual01,
      Individual02,
      Individual03,
      Individual04
    }
  },
  mounted () {

  }
}
</script>
<style lang="less" scoped>

.customer-block {
  border-bottom: 1px solid #e9ebf4;
  padding: 30px 0;
  .case-title {
    position: relative;
    font-size: 20px;
    color: #333130;
    line-height: 30px;
    padding-left: 25px;
    // margin-top: 35px;
    margin-bottom: 18px;
    &::before {
      position: absolute;
      left: 0;
      top: 8px;
      content: '';
      display: block;
      width: 12px;
      height: 12px;
      background: #343230;
    }
  }
  p {
    font-size: 16px;
    color: #333130;
  }
}
.experience-part {
  margin: 0 18px 0 0;
  border: none;
  padding: 0;
  .more-case {
    margin: 0 0 10px 0;
  }
}
.img-box {
  width: 800px;
  height: 258px;
  /*margin: 40px auto 99px auto;*/
}
.rescue-table {
  width: 100%;
  margin-bottom: 20px;
  td {
    border: 1px solid #e9ebf4;
    padding: 16px 34px;
  }
  h5 {
    font-size: 24px;
    color: #333130;
    line-height: 28px;
    margin-bottom: 10px;
  }
  p {
    font-size: 18px;
    color: #333130;
    line-height: 28px;
  }
}
.case-img {
  display: block;
  margin: 0 auto;
}
</style>